import _asyncToGenerator from "F:/vue2.0+ vant/2024\u5E74\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u5B98\u7F51\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u82F1\u6587\u7248\u672C/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
// import { tr } from 'element-plus/lib/locale'
import { onMounted, ref, reactive, computed } from 'vue';
import { enGetPartnerList_url } from "@/api"; //引入发送请求获取数据的方法

export default {
  components: {},
  name: 'Content',
  setup: function setup() {
    var partnerList = ref([]);
    var activeNames = ref(-1);

    var getPartnerList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return enGetPartnerList_url();

              case 2:
                res = _context.sent;
                // console.log(res,'这是合作伙伴列表'); 
                partnerList.value = res.data.partnerList;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getPartnerList() {
        return _ref.apply(this, arguments);
      };
    }();

    onMounted(function () {
      getPartnerList();
    });

    var jumpWeb = function jumpWeb(url) {
      window.open(url);
    };

    var retract = function retract(name) {
      activeNames.value = -1; // console.log(activeNames.value, '看看是什么')
      // activeNames.value = activeNames.value.filter(n => n !== name);
    };

    var toggleMore = function toggleMore(index) {
      // if (activeNames.value.includes(index.toString())) {
      //   activeNames.value = activeNames.value.filter(i => i !== index.toString());
      // } else {
      //   activeNames.value.push(index.toString());
      // }
      activeNames.value = index; // console.log(activeNames.value,'看看是啥')
    };

    return {
      partnerList: partnerList,
      activeNames: activeNames,
      jumpWeb: jumpWeb,
      retract: retract,
      toggleMore: toggleMore
    };
  }
};